/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} How_Page_Remind_BodyInputs */

const en_how_page_remind_body = /** @type {(inputs: How_Page_Remind_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A text the day before asking whether you will make it, and an e-mail in the morning with your day: the session, the exercises and the meals.`)
};

const pl_how_page_remind_body = /** @type {(inputs: How_Page_Remind_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dzień wcześniej SMS z pytaniem, czy będziesz, a rano e-mail z planem dnia: trening, ćwiczenia i posiłki.`)
};

/**
* | output |
* | --- |
* | "A text the day before asking whether you will make it, and an e-mail in the morning with your day: the session, the exercises and the meals." |
*
* @param {How_Page_Remind_BodyInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const how_page_remind_body = /** @type {((inputs?: How_Page_Remind_BodyInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<How_Page_Remind_BodyInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_how_page_remind_body(inputs)
	return en_how_page_remind_body(inputs)
});